import { render } from "./HeaderComponent.vue?vue&type=template&id=049cb020&scoped=true&ts=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=ts"
export * from "./HeaderComponent.vue?vue&type=script&lang=ts"

import "./HeaderComponent.vue?vue&type=style&index=0&id=049cb020&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049cb020"]])

export default __exports__